import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';
import Joi from 'joi-browser';
import Helmet from 'react-helmet';
// eslint-disable-next-line no-unused-vars
import parts from '../utilities/parts';

import _slideLoader from '../utilities/slideLoader';
import EventMg from '../utilities/EventManager';
import { validateByJoi } from '../utilities/validation';
import { FieldItemInputService } from '../services/FieldItemInputs';

import {
  WORK_HOUR_ZONES, // 作業時間帯
  SPOT_STATUS, // スポット利用ステータス
  SPOT_TIMES_DEFAULT,
  SCHEDULE_TYPES, // 予定種別
  HEADER_CONSTANTS, // ヘッダータイトル
  APPROVAL_STATUS, // 承認ステータス
  USER_ROLES_IDS,
  PRIVATE_PARTNER_COMPANY_LABEL,
} from '../utilities/constants'; // 定数ファイル

import dialogLoader from '../utilities/dialogLoader'; // ダイアログ
import { FieldService } from '../services/Fields'; // 現場マスタAPI
import { FieldItemService } from '../services/FieldItems'; // 現場作業エリア情報取得API
import { CraneService } from '../services/Cranes'; // 揚重機マスタAPI
import { CraneUseService } from '../services/CraneUses'; // 揚重機予定API
import { CraneUseForm } from '../components/forms/CraneUses';
import { messageUtility } from '../utilities/messageUtility';
import { isTargetRoleId } from '../utilities/roleUtility';
import { isNullOrEmpty, deleteControlCode } from '../utilities/stringUtil';
import {
  isCopyLatestError,
  isPrimeContractorHasBlockedOrFinishedWorkError,
  isWorkDateError,
} from '../utilities/apiErrorMessage';
import { ErrorDialog } from '../components/dialogs/ErrorDialog';
import { ConferencePageHeader } from '../components/PageHeader';
import { FormInformationDialog } from '../components/FormInformationDialog';

const MY_EVENT = {
  LOAD_CRANE_USES_DATA: 'load_crane_uses_data', // 一覧取得
};

/**
 * @description 揚重機予定登録・編集画面
 */
export class CraneUseRegister extends React.Component {
  constructor(props) {
    super(props);

    const date_from = !_.isUndefined(this.props.view.state.currentDate)
      ? this.props.view.state.currentDate
      : !_.isNull(sessionStorage.getItem('date_from'))
      ? sessionStorage.getItem('date_from')
      : moment().format('YYYY/MM/DD');

    this.state = {
      craneUseId: this.props.view.state.id,
      fieldId: sessionStorage.getItem('field_id'),
      roleId: localStorage.getItem('role_id'),
      // props.view.state.idは揚重機予定画面で選択したレコードのIDが入る(slideLoader.js publishView)
      isEdit: Number(this.props.view.state.id) > 0 ? true : false, // 編集フラグ
      isFirstLoaded: false, // 初回ロードフラグ
      viewOnlyFlag: this.props.view.state.viewOnlyFlag, // 閲覧制限フラグ
      workTime: {}, // 現場に設定されている作業時間を格納
      requiredInput: {
        count: this.props.view.state.id ? 5 : 1, // 期間は初期セット
        total: 5, // 必須項目数
      },
      validate: {
        validated: false, // 登録ボタン押下済みフラグ
        invalid: false, // 入力内容エラー
        messages: {}, // エラー内容
      },
      isSpot: false, // スポット利用（フォームの切り替えで使用）
      isSpotToggle: false, // スポット業者切替フラグ
      itemNames: [],
      options: {}, // プルダウン初期表示用データ
      loaded: false, // プルダウンの情報が取得できたか
      // プルダウンの初期name
      pulldownName: {
        company_name: '', // 協力会社名
        job_name: '', // 職種名
        foreman_user_name: '', // 職長名
        crane_name: '', // 揚重機名
        a_item_name: '', // 作業場所A名
        b_item_name: '', // 作業場所B名
        c_item_name: '', // 作業場所C名
        d_item_name: '', // 作業場所D名
        manager_user_name: '', // 元請担当者名
      },
      formValues: {
        userValueChangeFlag: false, // ユーザー操作フラグ
        approval_flag: APPROVAL_STATUS.unapproved.id, // 承認フラグ
        today_receipt_no: '', // 受付No
        use_date: '', // 作業日
        use_date_start: date_from, // 作業範囲(開始)
        use_date_end: date_from, // 作業範囲(終了)
        field_tree_id: null, // 協力会社ID
        job_id: null, // 職種ID
        foreman_user_id: null, // 職長ID
        spot_company_name: '', // スポット利用会社名
        spot_foreman_user_name: '', // スポット利用職長名\
        spot_foreman_user_job: '', // スポット対象職種
        crane_id: null, // 揚重機ID
        company_name: '', // 管理会社名
        operator_name: '', // オペレーター
        spec_form: '', // 性能
        a_item_id: null, // 作業場所A
        b_item_id: null, // 作業場所B
        c_item_id: null, // 作業場所C
        d_item_id: null, // 作業場所D
        safety_instruction: '', // 安全事項
        slinging_worker_high_name: '', // 玉掛者1
        slinging_worker_low_name: '', // 玉掛者2
        signal_worker_high_name: '', // 合図者1
        signal_worker_low_name: '', // 合図者2
        luggage: '', // 荷種
        work_contents: '', // 作業内容
        use_start_time: '', // 作業開始時刻
        use_end_time: '', // 作業終了時刻
        spot_flag: SPOT_STATUS.normal.id,
        spot_time: '', // スポット時間
        manager_user_id: null, // 元請担当ID
        work_hour_zone: sessionStorage.getItem('work_hour_zone'), // 作業時間帯
        schedule_type: SCHEDULE_TYPES.crane.id, // 揚重機予定
      },
    };

    this.events = {
      dialog: {
        goBack: this.handleGoBackDialog.bind(this),
        copy: this.handleCopyDialog.bind(this),
        showDelete: this.handleDeleteDialog.bind(this),
      },
      form: {
        set: this.setFlatData.bind(this),
        setTime: this.setTime.bind(this), // 開始・終了時間セット
        calender: this.setDate.bind(this),
        crane: this.setCraneDropdownData.bind(this),
        submit: this.eventSubmit.bind(this),
        update: this.eventUpdate.bind(this),
        setSpot: this.setSpotFlag.bind(this),
        setSpotStatus: this.setSpotStatus.bind(this),
        validate: this.validate.bind(this), // バリデーション
      },
    };

    this.updatingFlag = false; // 多重更新防止Flag

    this.initForm = this.initForm.bind(this); // フォーム生成
    this.setCraneDetails = this.setCraneDetails.bind(this); // 選択した揚重機情報取得
    this.deleteCraneUse = this.deleteCraneUse.bind(this); // 予定削除
    this.checkRequired = this.checkRequired.bind(this); // 必須項目入力状況監視

    // 前回コピーダイアログ
    this.LatestCopy = {
      callback: {
        copy: () => {
          this.getLatestCraneUse();
          dialogLoader.close();
        },
      },
    };

    // 削除ダイアログ
    this.DeleteCraneUse = {
      callback: {
        deleteSchedule: () => {
          this.deleteCraneUse();
          dialogLoader.close();
        },
      },
    };

    // 戻るダイアログ
    this.GoBack = {
      callback: {
        goBack: () => {
          _slideLoader.close(this.props.vw);
          EventMg.trigger(MY_EVENT.LOAD_CRANE_USES_DATA);
          dialogLoader.close();
        },
      },
    };
  }

  /**
   * 現場情報を取得し、作業時間をセット
   */
  componentDidMount() {
    FieldService.info(this.state.fieldId).then(response => {
      if (response.result) {
        const field = response.data.entities.field;
        const workTime = _.cloneDeep(this.state.workTime);
        const fieldItemDetails = response.data.entities.field.field_items;

        workTime[WORK_HOUR_ZONES.day.id] = _.assign(
          workTime[WORK_HOUR_ZONES.day.id],
          { start: field.work_start_time, end: field.work_end_time }
        );
        workTime[WORK_HOUR_ZONES.night.id] = _.assign(
          workTime[WORK_HOUR_ZONES.night.id],
          { start: field.work_start_time_night, end: field.work_end_time_night }
        );

        workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
          workTime[WORK_HOUR_ZONES.midnight.id],
          {
            start: field.work_start_time_midnight,
            end: field.work_end_time_midnight,
          }
        );

        const item_list_ids = [1, 2, 3, 4];
        _.map(item_list_ids, (itemListId, key) => {
          if (
            fieldItemDetails[`field_item_list${itemListId}_display_flag`] === 0
          ) {
            item_list_ids.splice(key, 1);
          }
        });

        if (item_list_ids.length === 0) {
          this.setState({
            workTime,
            fieldItemDetails,
          });
        } else {
          // 作業場所(item_list_ids)項目があれば作業エリア情報取得する
          const params = {
            item_list_ids,
            is_limit: 1,
            offset: 0,
            limit: 30,
            // 有効のものだけ表示
            display_flag: 1,
          };

          // 現場作業エリア情報取得API
          FieldItemService.list(this.state.fieldId, params).then(response => {
            if (response.result === false) {
              return;
            }

            this.setState({
              workTime,
              fieldItemDetails,
              options: response.data.entities,
              loaded: true,
            });
          });
        }

        if (this.state.craneUseId > 0) {
          CraneUseService.show(this.state.fieldId, this.state.craneUseId).then(
            response => {
              if (response.result) {
                this.initForm(response.data.entities.crane_use);
              }
            }
          );
        }
      }
    });
    this.getItemListTitle();
  }

  componentDidUpdate(prevProps, prevState) {
    // 揚重機予定編集画面でスポット業者へ切り替えを行った場合、一度だけ実行
    if (
      prevState.isSpot !== this.state.isSpot &&
      !this.state.isSpotToggle &&
      this.state.isEdit
    ) {
      const pulldownName = { ...this.state.pulldownName };
      delete pulldownName.company_name;
      this.setState({ isSpotToggle: true, pulldownName });
    }
  }

  /**
   * 戻るダイアログ表示
   */
  handleGoBackDialog = () => {
    dialogLoader.show(GoBackDialog, this.GoBack);
  };

  /**
   * 前回コピーダイアログ表示
   */
  handleCopyDialog = () => {
    dialogLoader.show(LatestCopyDialog, this.LatestCopy);
  };

  /**
   * 削除ダイアログ
   */
  handleDeleteDialog = () => {
    dialogLoader.show(DeleteDialog, this.DeleteCraneUse);
  };

  /**
   * フォーム生成
   * @param data {object} machinery_use
   * @param isCopyLatest {boolean} 前回コピーフラグ
   */
  initForm(data, isCopyLatest = false) {
    // console.log(
    //   'CraneUseRegister.jsx initForm',
    //   Object.keys(data).join(','),
    //   Object.keys(this.state.formValues).join(','),
    //   Object.keys(this.state.pulldownName).join(',')
    // );

    // if (
    //   !parts.object.inProperty(
    //     data,
    //     'id, field_id, field_tree_id,' +
    //       'company_name_1, company_name_2, company_name_3, company_name_4, company_name_5,' +
    //       'nest_no, crane_id, use_date, today_receipt_no,' +
    //       'foreman_user_id, foreman_user_name_sei, foreman_user_name_mei,' +
    //       'company_name, spot_company_name, spot_foreman_user_name, spot_contact_info,' +
    //       'use_start_time, use_end_time, co2_emissions,' +
    //       'a_item_id, a_item_name, b_item_id, b_item_name, c_item_id, c_item_name, d_item_id, d_item_name,' +
    //       'work_area, work_location, work_contents, luggage, slinging_worker_high_name, slinging_worker_low_name,' +
    //       'signal_worker_high_name, signal_worker_low_name, manager_user_id, manager_user_name,' +
    //       'safety_instruction, block_flag, approval_flag, work_hour_zone, schedule_type,' +
    //       'spot_flag, spot_time, spot_foreman_user_job,' +
    //       'job_id, job_name, created_at, updated_at, create_user_id, update_user_id, crane_name' +
    //       ''
    //   )
    // ) {
    //   throw new Error('GatePassageEdit.jsx initForm data inProperty');
    // }
    // if (
    //   !parts.object.inProperty(
    //     this.state.formValues,

    //     'userValueChangeFlag, approval_flag, today_receipt_no,' +
    //       'use_date, use_date_start, use_date_end,' +
    //       'field_tree_id, job_id, foreman_user_id,' +
    //       'spot_company_name, spot_foreman_user_name, spot_foreman_user_job, crane_id,' +
    //       'company_name, operator_name, spec_form,' +
    //       'a_item_id, b_item_id, c_item_id, d_item_id,' +
    //       'safety_instruction,' +
    //       'slinging_worker_high_name, slinging_worker_low_name, signal_worker_high_name,' +
    //       'signal_worker_low_name, luggage, work_contents,' +
    //       'use_start_time, use_end_time, spot_flag, spot_time,' +
    //       'manager_user_id, work_hour_zone, schedule_type' +
    //       ''
    //   )
    // ) {
    //   throw new Error(
    //     'GatePassageEdit.jsx initForm this.state.formValues inProperty'
    //   );
    // }
    // if (
    //   !parts.object.inProperty(
    //     this.state.pulldownName,
    //     'company_name, job_name, foreman_user_name, crane_name,' +
    //       'a_item_name, b_item_name, c_item_name, d_item_name, manager_user_name' +
    //       ''
    //   )
    // ) {
    //   throw new Error(
    //     'GatePassageEdit.jsx initForm this.state.pulldownName inProperty'
    //   );
    // }

    const formValues = {};
    const pulldownName = {};
    _.each(data, (value, key) => {
      if (_.has(this.state.formValues, key)) {
        formValues[key] = _.defaultTo(value, '');
      }
    });
    // this.state.formValues.xxx の値を data.xxx で上書きするために
    // formValues.xxx に値を代入する

    // console.log('CraneUseRegister.jsx', 'initForm', 2, formValues);

    // プルダウンの名前の初期値を取得
    pulldownName.company_name = data.company_name; // 協力会社名
    if (data.private_partner_company_flag) {
      pulldownName.company_name += PRIVATE_PARTNER_COMPANY_LABEL;
    }
    pulldownName.job_name = data.job_name; // 職名
    pulldownName.foreman_user_name = data.foreman_user_name_sei
      ? `${data.foreman_user_name_sei} ${data.foreman_user_name_mei}`
      : ''; // 職長名
    pulldownName.crane_name = data.crane_name; // 揚重機名
    pulldownName.a_item_name = data.a_item_name; // 作業場所A名
    pulldownName.b_item_name = data.b_item_name; // 作業場所B名
    pulldownName.c_item_name = data.c_item_name; // 作業場所C名
    pulldownName.d_item_name = data.d_item_name; // 作業場所D名
    pulldownName.manager_user_name = data.manager_user_name; // 元請担当者名(sei,meiを結合)

    // スポットフラグ
    if (data.spot_time) {
      formValues.spot_flag = 1;
    }

    // 開始終了日・予定種別
    formValues.use_date_start = this.state.formValues.use_date_start;
    formValues.use_date_end = this.state.formValues.use_date_end;
    formValues.schedule_type = SCHEDULE_TYPES.crane.id;
    // 揚重機詳細
    if (data.crane_id === null) {
      console.log(`initFrom crane_id null ${data.crane_id}`);
    } else {
      console.log(`initFrom crane_id not null ${data.crane_id}`);
    }
    if (data.crane_id > 0) {
      this.setCraneDetails(data.crane_id, formValues);
    }

    let viewOnlyFlag = false;
    // 更新時のみ編集可能かチェック 前回コピーの場合は必ず登録可能
    if (this.state.isEdit) {
      // 協力会社ユーザーの場合、現在日付がpassage_dateより後の日付 || 他社の予定は編集不可とする
      if (
        (isTargetRoleId(USER_ROLES_IDS.PARTNER_COMPANY, this.state.roleId) &&
          moment().isAfter(formValues.use_date, 'days')) ||
        (_.has(data, 'permissions') && data.permissions.edit === false)
      ) {
        viewOnlyFlag = true;
      }
    }

    this.setState(
      {
        formValues,
        pulldownName,
        viewOnlyFlag,
        isFirstLoaded: true,
        isSpot: data.spot_company_flag,
      },
      () => {
        if (isCopyLatest) {
          this.validate();
        } else {
          this.checkRequired(formValues);
        }
      }
    );
  }

  /**
   * 入力値の有効判定
   * @param formValues {object}
   * @return bool
   */
  validate(name, updateValues = {}) {
    // 編集権限がない場合、エラーチェックは行わない
    if (this.state.viewOnlyFlag) {
      return;
    }
    const checkValues = {
      ...this.state.formValues,
      ...updateValues,
    };
    const values = {};
    _.map(checkValues, (value, index) => {
      values[index] = _.isNull(value) ? '' : `${value}`;
    });

    // 基本項目
    const schema = {
      approval_flag: Joi.string().allow(null, ''), // 承認フラグ
      today_receipt_no: Joi.string()
        .allow(null, '')
        .max(255), // 受付番号
      use_date_start: Joi.string().allow(null, ''), // 開始日
      use_date_end: Joi.string().allow(null, ''), // 終了日
      use_date: Joi.string().allow(null, ''), // 作業日
      field_tree_id: Joi.string().allow(null, ''), // 車輌手配業者
      job_id: Joi.string().allow(null, ''), // 職種
      foreman_user_id: Joi.string().allow(null, ''), // 職長
      spot_company_name: Joi.string()
        .max(255)
        .allow(null, ''), // スポット利用会社名
      spot_foreman_user_job: Joi.string()
        .max(255)
        .allow(null, ''), // スポット対象職種
      spot_foreman_user_name: Joi.string()
        .max(255)
        .allow(null, ''), // スポット利用職長名
      crane_id: Joi.string().required(), // 揚重機ID
      company_name: Joi.string().allow(null, ''), // 揚重機管理会社名
      operator_name: Joi.string().allow(null, ''), // オペレーター
      spec_form: Joi.string().allow(null, ''), // 性能
      a_item_id: Joi.string().allow(null, ''), // 作業場所A
      b_item_id: Joi.string().allow(null, ''), // 作業場所B
      c_item_id: Joi.string().allow(null, ''), // 作業場所C
      d_item_id: Joi.string().allow(null, ''), // 作業場所D
      safety_instruction: Joi.string()
        .max(512)
        .allow(null, ''), // 安全事項
      slinging_worker_high_name: Joi.string()
        .max(255)
        .allow(null, ''), // 玉掛者1
      slinging_worker_low_name: Joi.string()
        .max(255)
        .allow(null, ''), // 玉掛者2
      signal_worker_high_name: Joi.string()
        .max(255)
        .allow(null, ''), // 合図者1
      signal_worker_low_name: Joi.string()
        .max(255)
        .allow(null, ''), // 合図者2
      luggage: Joi.string()
        .max(255)
        .allow(null, ''), // 荷種
      work_contents: Joi.string()
        .max(255)
        .required(), // 作業内容
      use_start_time: Joi.string().required(), // 開始時間
      use_end_time: Joi.string().required(), // 終了時間
      spot_flag: Joi.number().allow(null, ''), // スポット作業ON/OFF
      spot_time: Joi.string().allow(null, ''), // スポット時間
      manager_user_id: Joi.string().allow(null, ''), // 元請担当者
      work_hour_zone: Joi.string().required(), // 作業時間帯
      schedule_type: Joi.string().required(), // ゲート予定
    };

    // スポット業者
    if (this.state.isSpot) {
      schema.spot_company_name = Joi.string()
        .max(255)
        .required(); // スポット利用会社名
    } else {
      schema.field_tree_id = Joi.string().required(); // 車輌手配業者
    }

    const result = validateByJoi(Joi.object().keys(schema), values);
    const validate = _.cloneDeep(this.state.validate);
    const targetUseDateKey = this.state.isEdit ? 'use_date' : 'use_date_start';
    // エラーメッセージをセット
    if (name) {
      if (_.has(result.messages, name)) {
        validate.messages[name] = result.messages[name];
        validate.invalid = true;
      } else if (name === 'use_start_time' || name === 'use_end_time') {
        delete validate.messages.use_start_time;
        delete validate.messages.use_end_time;
      } else if (validate.messages[name]) {
        delete validate.messages[name];
      }
      // 日付チェック
      const later = moment(values.use_date_start, 'YYYY/MM/DD').add(30, 'days');
      if (moment(values.use_date_end).isAfter(later)) {
        validate.messages.use_date_start = '30日以上は選択できません。';
        validate.invalid = true;
      } else if (
        moment(values.use_date_start, 'YYYY/MM/DD').isAfter(values.use_date_end)
      ) {
        validate.messages.use_date_start =
          '開始日が終了日より後の日付になっています。';
        validate.invalid = true;
      } else {
        delete validate.messages.use_date_start;
      }

      // 協力会社ユーザーでログイン時、
      // 開始日(From)が現在日より前の日付に設定されていたらエラー
      const targetUseDate = this.state.isEdit
        ? values.use_date
        : values.use_date_start;
      if (
        isTargetRoleId(USER_ROLES_IDS.PARTNER_COMPANY, this.state.roleId) &&
        moment().isAfter(targetUseDate, 'days')
      ) {
        validate.messages[targetUseDateKey] = messageUtility.getMessage(
          'E-001-313'
        );
        validate.invalid = true;
      }
    } else {
      if (!isNullOrEmpty(validate.messages[targetUseDateKey])) {
        if (_.has(result, 'messages')) {
          result.messages[targetUseDateKey] =
            validate.messages[targetUseDateKey];
        } else {
          result.messages = {};
          result.messages[targetUseDateKey] =
            validate.messages[targetUseDateKey];
        }
      }
      if (_.size(result.messages) > 0) {
        validate.messages = result.messages;
      } else {
        validate.messages = [];
      }
    }
    if (Object.keys(validate.messages).length === 0) {
      validate.invalid = false;
    } else {
      validate.invalid = true;
    }

    this.setState({ validate });
    // 必須チェック
    this.checkRequired(values);
    return Object.keys(validate.messages).length;
  }

  /**
   * 必須入力状況チェック
   * @param values {object} 入力値
   */
  checkRequired(values) {
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    const requiredColumns = [
      'use_date_start',
      'work_contents',
      this.state.isSpot ? 'spot_company_name' : 'field_tree_id',
    ];
    let cnt = 0;

    // 期間、協力会社、作業内容
    _.each(requiredColumns, column => {
      if (!isNullOrEmpty(values[column])) {
        cnt += 1;
      }
    });

    // 揚重機
    if (!isNullOrEmpty(values.crane_id) && values.crane_id !== '0') {
      cnt += 1;
    }

    // 時間
    if (values.use_start_time !== '' && values.use_end_time !== '') {
      cnt += 1;
    }

    requiredInput.count = cnt;
    this.setState({ requiredInput });
  }

  /**
   * 入力値をformValuesにセット
   * ドロップダウンで選択したデータをstateへ保存
   * @param name {string}
   * @param value {any}
   */
  setFlatData = (name, value) => {
    this.setState(prevState => {
      const formValues = _.cloneDeep(prevState.formValues);
      formValues[name] = _.defaultTo(deleteControlCode(value), '');

      // 揚重機予定 の編集画面で
      // 協力会社Dropdownが動作した時に
      // 職種Dropdown 職長Dropdown の初期化が行われる
      // 不具合[BLDE_V2-17211]として、内部値が更新されていない問題があり
      // この箇所で内部値をクリアしておく

      // 協力会社:field_tree_id
      // 職種:job_id
      // 職長:foreman_user_id
      if (
        name === 'field_tree_id' &&
        this.state.formValues.field_tree_id !== value
      ) {
        // 協力会社に変更があった場合は、職種|職長の値は初期化される
        formValues.job_id = null;
        formValues.foreman_user_id = null;
        formValues.userValueChangeFlag = true;
      } else if (name === 'job_id' && this.state.formValues.job_id !== value) {
        // 職種に変更があった場合は、職長の値は初期化される
        formValues.foreman_user_id = null;
        formValues.userValueChangeFlag = true;
      }
      return {
        formValues,
      };
    });
  };

  /**
   * カレンダー日付セット
   * @param name {string}
   * @param date {string}
   * カレンダーの更新に連動して揚重機の情報を更新する
   */
  setDate = (name, date) => {
    const formValues = _.cloneDeep(this.state.formValues);
    if (formValues[name] !== date) {
      formValues[name] = date;
      if (formValues.crane_id > 0) {
        this.setCraneDetails(formValues.crane_id, { [name]: date });
      }
      this.validate(name, { [name]: date });
      this.setState({ formValues });
    }
  };

  /**
   * スポット業者設定ハンドリング
   * @param spotFlag {int}
   */
  setSpotFlag = spotFlag => {
    const formValues = _.cloneDeep(this.state.formValues);
    let isSpot = this.state.isSpot;
    const validate = _.cloneDeep(this.state.validate);
    if (spotFlag === SPOT_STATUS.spot.id) {
      formValues.field_tree_id = null;
      formValues.job_id = null;
      formValues.foreman_user_id = null;
      if (validate.messages.field_tree_id) {
        delete validate.messages.field_tree_id;
      }
      isSpot = true;
    } else if (spotFlag === SPOT_STATUS.normal.id) {
      formValues.spot_company_name = '';
      formValues.spot_foreman_user_job = '';
      formValues.spot_foreman_user_name = '';
      if (validate.messages.spot_company_name) {
        delete validate.messages.spot_company_name;
      }
      isSpot = false;
    }
    if (Object.keys(validate.messages).length === 0) {
      validate.invalid = false;
    }

    this.setState({
      formValues,
      isSpot,
      validate,
    });
  };

  /**
   * スポットフラグ設定
   * @param checked {boolean}
   */
  setSpotStatus = checked => {
    if (this.state.formValues.approval_flag === APPROVAL_STATUS.approval.id) {
      return;
    }
    const formValues = _.cloneDeep(this.state.formValues);
    if (checked) {
      formValues.spot_flag = SPOT_STATUS.normal.id;
      formValues.spot_time = '';
    } else {
      formValues.spot_flag = SPOT_STATUS.spot.id;
      formValues.spot_time = SPOT_TIMES_DEFAULT;
    }

    this.setState({ formValues });
  };

  /**
   * 揚重機マスタ情報セット
   * @param craneId {int}
   */
  setCraneDetails(craneId, paramValues = {}) {
    paramValues = {
      ...this.state.formValues,
      ...paramValues,
    };
    let param = {
      field_id: this.state.fieldId,
      work_hour_zone: sessionStorage.getItem('work_hour_zone'),
      crane_id: [craneId],
    };
    if (this.state.isEdit) {
      param = {
        ...param,
        use_date_from: paramValues.use_date,
        use_date_to: paramValues.use_date,
      };
    } else {
      param = {
        ...param,
        use_date_from: paramValues.use_date_start,
        use_date_to: paramValues.use_date_end,
      };
    }
    const emptyValues = {
      company_name: '',
      operator_name: '',
      spec_form: '',
    };
    // 予定がすでにあればlist_for_crane_usesのデータを使う
    CraneService.listForCraneUses(this.state.fieldId, param).then(response => {
      if (response.result) {
        const crane = response.data.entities.cranes[0];
        if (crane) {
          const formValues = {
            ...this.state.formValues,
            ...emptyValues,
          };
          formValues.company_name = crane.partner_company_name;
          if (
            crane.crane_operator_schedules &&
            crane.crane_operator_schedules.length != 0
          ) {
            formValues.operator_name =
              crane.crane_operator_schedules[0].operator_name;
          }
          formValues.spec_form = crane.spec_form;
          // データ要求時の日時が現在の日時が異なるときは棄却
          if (this.state.isEdit) {
            if (paramValues.use_date === formValues.use_date) {
              this.setState({ formValues });
            }
          } else {
            if (
              paramValues.use_date_start === formValues.use_date_start &&
              paramValues.use_date_end === formValues.use_date_end
            ) {
              this.setState({ formValues });
            }
          }
        } else {
          // 予定がなければオペレータの情報なしでcraneのマスタデータを使う
          CraneService.show(this.state.fieldId, craneId).then(response => {
            if (!response.result) {
              return;
            }
            const formValues = {
              ...this.state.formValues,
              ...emptyValues,
            };
            const crane = response.data.entities.crane;
            formValues.company_name = crane.partner_company_name;
            formValues.spec_form = crane.spec_form;
            // データ要求時の日時が現在の日時が異なるときは棄却
            if (this.state.isEdit) {
              if (paramValues.use_date === formValues.use_date) {
                this.setState({ formValues });
              }
            } else {
              if (
                paramValues.use_date_start === formValues.use_date_start &&
                paramValues.use_date_end === formValues.use_date_end
              ) {
                this.setState({ formValues });
              }
            }
          });
        }
      }
    });
  }

  /**
   * ドロップダウンで選択した揚重機情報をstateへ保存
   * @param name {string}
   * @param value {int}
   */
  setCraneDropdownData = (name, value) => {
    const formValues = _.cloneDeep(this.state.formValues);
    formValues.crane_id = value;
    if (value) {
      this.setCraneDetails(value);
    } else {
      formValues.company_name = '';
      formValues.operator_name = '';
      formValues.spec_form = '';
    }
    this.setState({ formValues });
  };

  /**
   * 前回コピー
   */
  getLatestCraneUse() {
    CraneUseService.latestRegistration(this.state.fieldId, {
      work_hour_zone: sessionStorage.getItem('work_hour_zone'),
      date: this.state.formValues.use_date_start,
    }).then(response => {
      if (response.result) {
        if (_.isEmpty(response.data.entities.crane_use)) {
          alert('前回データが存在しません。');
        } else {
          const craneUse = response.data.entities.crane_use;
          craneUse.approval_flag = APPROVAL_STATUS.unapproved.id;
          this.initForm(craneUse, true);
        }
      } else {
        const message = _.get(response, 'data.message');
        if (isCopyLatestError(message)) {
          return dialogLoader.show(FormInformationDialog, {
            title: messageUtility.getMessage('E-001-402'),
            message,
            onClose: () => {
              dialogLoader.close();
            },
          });
        }
      }
    });
  }

  /**
   * 登録
   */
  eventSubmit = () => {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    let validate = this.validate();
    if (validate !== 0) {
      this.updatingFlag = false;
      return;
    }
    CraneUseService.create(this.state.fieldId, this.state.formValues).then(
      response => {
        this.onSaveCompleted(response, false);
      }
    );
  };

  /**
   * 更新
   */
  eventUpdate = () => {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    let validate = this.validate();
    if (validate !== 0) {
      this.updatingFlag = false;
      return;
    }
    CraneUseService.update(this.state.fieldId, this.state.craneUseId, {
      ...this.state.formValues,
      from_crane_use_edit: 1,
    }).then(response => {
      this.onSaveCompleted(response, true);
    });
  };

  onSaveCompleted = (response, isEdit) => {
    if (response.message) {
      if (isWorkDateError(response.message)) {
        const validate = _.cloneDeep(this.state.validate);
        if (isEdit) {
          validate.messages.use_date = response.message;
        } else {
          validate.messages.use_date_start = response.message;
        }
        validate.invalid = true;
        this.setState({ validate });
      } else {
        if (
          isPrimeContractorHasBlockedOrFinishedWorkError(response.message)
        ) {
          return dialogLoader.show(FormInformationDialog, {
            title: messageUtility.getMessage('E-001-422'),
            message: messageUtility.getMessage('E-001-423'),
            onClose: () => {
              window.location.reload();
            },
          });
        }
        dialogLoader.show(ErrorDialog, {
          message: response.message,
          callback: {
            close: () => {
              dialogLoader.close();
            },
          },
        });
      }
    } else if (response.result) {
      _slideLoader.close(this.props.vw);
      EventMg.trigger(MY_EVENT.LOAD_CRANE_USES_DATA);
    }
    this.updatingFlag = false;
  };

  /**
   * 揚重機予定削除
   */
  deleteCraneUse() {
    CraneUseService.deleteSchedule(
      this.state.fieldId,
      this.state.craneUseId
    ).then(response => {
      if (response.result) {
        _slideLoader.close(this.props.vw);
        EventMg.trigger(MY_EVENT.LOAD_CRANE_USES_DATA);
      }
    });
  }

  /**
   * 入力値をformValuesにセット
   */
  setTime = e => {
    const selectedIndex = e.target.selectedIndex;
    const selected = e.target.options[selectedIndex];
    const selectedDate = selected.getAttribute('data-select');
    const target = moment(selectedDate);
    const formValues = _.cloneDeep(this.state.formValues);
    const name = e.target.name;
    const value = e.target.value;
    formValues[name] = value;
    if (name === 'use_start_time') {
      if (!formValues.use_end_time) {
        formValues.use_end_time = target.add(15, 'minutes').format('HH:mm:ss');
      } else {
        const endSelect = document.getElementById('crane-uses-use-end-time');
        const endIndex = endSelect.selectedIndex;
        const endSelected = endSelect.options[endIndex];
        const end = moment(endSelected.getAttribute('data-select'));
        if (end.isSameOrBefore(target)) {
          formValues.use_end_time = target
            .add(15, 'minutes')
            .format('HH:mm:ss');
        }
      }
    } else if (name === 'use_end_time') {
      if (!formValues.use_start_time) {
        formValues.use_start_time = target
          .add(-15, 'minutes')
          .format('HH:mm:ss');
      } else {
        const startSelect = document.getElementById(
          'crane-uses-use-start-time'
        );
        const startIndex = startSelect.selectedIndex;
        const startSelected = startSelect.options[startIndex];
        const start = moment(startSelected.getAttribute('data-select'));
        if (start.isSameOrAfter(target)) {
          formValues.use_start_time = target
            .add(-15, 'minutes')
            .format('HH:mm:ss');
        }
      }
    }
    this.setState({ formValues });
  };

  getItemListTitle() {
    FieldItemInputService.itemNames(this.state.fieldId).then(itemNames =>
      this.setState({ itemNames })
    );
  }

  render() {
    const { isFirstLoaded, viewOnlyFlag, formValues } = this.state;

    const createPageTitle = ({ isEdit, isFirstLoaded, approved }) => {
      if (!isEdit) {
        return '揚重機予定新規作成';
      }
      if (!isFirstLoaded) {
        return '';
      }
      switch (approved) {
        case APPROVAL_STATUS.approval.id:
          return '承認済揚重機予定';
        case APPROVAL_STATUS.unapproved.id:
          return '揚重機予定編集';
        default:
          return '';
      }
    };
    const pageTitle = createPageTitle({
      isEdit: this.state.isEdit,
      isFirstLoaded,
      approved: formValues.approval_flag,
    });

    return (
      <div className='slide-view show'>
        <Helmet>
          <title>{`${HEADER_CONSTANTS.conference} - ${pageTitle}`}</title>
        </Helmet>
        <div className='slide-view__view'>
          <CraneUseRegisterHeader
            isEdit={this.state.isEdit}
            isFirstLoaded={isFirstLoaded}
            viewOnlyFlag={viewOnlyFlag}
            callbacks={this.events}
            approved={formValues.approval_flag}
            pageTitle={pageTitle}
            validate={this.state.validate}
            requiredInput={this.state.requiredInput}
            vw={this.props.vw}
          />
          <CraneUseForm
            roleId={this.state.roleId}
            isSpot={this.state.isSpot}
            isSpotToggle={this.state.isSpotToggle}
            isEdit={this.state.isEdit}
            values={formValues}
            errors={this.state.validate.messages}
            workTime={this.state.workTime}
            viewOnlyFlag={
              formValues.approval_flag === APPROVAL_STATUS.approval.id ||
              viewOnlyFlag
            }
            events={this.events}
            itemNames={this.state.itemNames}
            fieldItemDetails={this.state.fieldItemDetails}
            pulldownName={this.state.pulldownName}
            options={this.state.options}
            loaded={this.state.loaded}
          />
        </div>
      </div>
    );
  }
}

/**
 * 登録・更新ヘッダー
 */
const CraneUseRegisterHeader = ({
  isEdit,
  isFirstLoaded,
  viewOnlyFlag,
  callbacks,
  approved,
  pageTitle,
  validate,
  requiredInput,
  vw,
}) => {
  return (
    <ConferencePageHeader
      title={<div className='slide-view__title'>{pageTitle}</div>}
      leftComponent={
        isEdit ? (
          <React.Fragment>
            {approved !==
            APPROVAL_STATUS.unapproved
              .id ? null : !isFirstLoaded ? null : viewOnlyFlag ? null : (
              <React.Fragment>
                <button
                  id='open-confirm-close'
                  className='btn--effective slide-view__header--button'
                  onClick={() => callbacks.form.update()}
                >
                  更新
                </button>
                <button
                  id='open-confirm-close'
                  className='btn--negative slide-view__header--button'
                  onClick={() => callbacks.dialog.showDelete()}
                >
                  削除
                </button>
              </React.Fragment>
            )}
          </React.Fragment>
        ) : (
          <button
            id='open-confirm-close'
            className='btn--effective slide-view__header--button'
            onClick={() => callbacks.form.submit()}
          >
            登録
          </button>
        )
      }
      rightComponent={
        <React.Fragment>
          <div className='slide-view__header-end-item'>
            <div className='form-list__header-alert show'>
              {validate.invalid ? '入力エラーがあります。' : ''}
            </div>
          </div>
          <div className='slide-view__header-end-item'>
            {`必須項目の入力数 ${requiredInput.count}/${requiredInput.total}`}
          </div>
        </React.Fragment>
      }
      onClose={() =>
        approved !== APPROVAL_STATUS.unapproved.id
          ? _slideLoader.close(vw)
          : callbacks.dialog.goBack()
      }
    />
  );
};

/**
 * 前回コピー
 * 前回登録した内容にフォームを上書き
 */
class LatestCopyDialog extends React.Component {
  render() {
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>前回登録した内容をコピー</span>
        </div>
        <div className='dialog-md__body text-center'>
          <p>現在編集中のデータを上書きします。よろしいですか？</p>
          <p>※この操作は取り消せません。</p>
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            id='modal-close-copy'
            className='btn--sm--sub'
            onClick={() => dialogLoader.close()}
          >
            戻る
          </button>
          <button
            id='modal-submit-copy'
            className='btn--sm--effective'
            onClick={() => {
              this.props.dialog.callback.copy();
            }}
          >
            コピーする
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 戻るボタン押下
 * 一覧へ遷移 or なにもしない
 */
class GoBackDialog extends React.Component {
  render() {
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>
            {messageUtility.getMessage('I-000-025')}
          </span>
        </div>
        <div className='dialog-md__body text-left'>
          {messageUtility.getMessage('I-000-confirmCloseEditWindow')}
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            id='modal-close-copy'
            className='btn--sub'
            onClick={() => dialogLoader.close()}
          >
            戻る
          </button>
          <button
            id='modal-close-copy'
            className='btn--negative'
            onClick={() => {
              this.props.dialog.callback.goBack();
            }}
          >
            {messageUtility.getMessage('I-000-025')}
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 削除ダイアログ
 */
class DeleteDialog extends React.Component {
  render() {
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>揚重機予定の削除</span>
        </div>
        <div className='dialog-md__body text-center'>
          データを削除します。この作業は取り消せません
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            id='modal-close-copy'
            className='btn--sm--sub'
            onClick={() => dialogLoader.close()}
          >
            戻る
          </button>
          <button
            id='modal-submit-copy'
            className='btn--sm--negative'
            onClick={() => {
              this.props.dialog.callback.deleteSchedule();
            }}
          >
            削除
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CraneUseRegister.jsx